import Grid from "@mui/material/Grid";
import Skeleton from "@mui/material/Skeleton";

export function FormSkeletonLoading() {
  const sectionTitle = (
    <Grid item xs={12} md={12} my={1}>
      <Skeleton width={150} height={20} />
      <Skeleton height={5} />
    </Grid>
  );
  const textInput = (
    <Grid item xs={12} md={6}>
      <Skeleton height={60} />
    </Grid>
  );

  return (
    <Grid container spacing={2}>
      {sectionTitle}
      {textInput}
      {textInput}
      {sectionTitle}
      {textInput}
      {textInput}
      {textInput}
      {textInput}
      {textInput}
      {sectionTitle}
      {textInput}
      {textInput}
      {textInput}
      {textInput}
    </Grid>
  );
}
